import React from 'react';
import {
  MPFCardCarousel,
  type MPFCardCarouselSlide,
} from 'volto-ministerio-publico-federal/components/UI';
import { IniciativaOverlayCard } from './IniciativaOverlayCard';
import type { IniciativaCard } from './helpers';

interface IniciativasCarouselMobileProps {
  /** Os três cards curados, na ordem da lista — que é a ordem do bento. */
  cards: IniciativaCard[];
  isEditMode?: boolean;
  /** Presente só no editor: recebe o índice do card em `data.items`. */
  onEditItem?: (index: number) => void;
}

/**
 * A faixa "Iniciativas e Projetos" abaixo de `lg`: um carrossel.
 *
 * No desktop os três cards formam um bento — um alto à esquerda e dois
 * empilhados à direita. Abaixo de `lg` não há bento: o carrossel mostra ~2
 * cards por vez (`slidesPerView` 2,2), com o terceiro cortado na borda direita
 * indicando que há mais. No celular os cards entram na versão `dense`
 * (padding, tag, título e botão menores); do `md` em diante têm o tamanho
 * normal. Todos os slides têm a mesma altura (`h-full`).
 *
 * Todos entram na variante `hero` (foto na escala grande, e o `eager`); o
 * título só cresce para 24px no bento, a partir de `lg`.
 *
 * Sem setas (`showArrows={false}`): no toque quem navega é o dedo, e os
 * bullets do Swiper já são focáveis pelo teclado (módulo `A11y`).
 */
export const IniciativasCarouselMobile: React.FC<
  IniciativasCarouselMobileProps
> = ({ cards, isEditMode, onEditItem }) => {
  const slides: MPFCardCarouselSlide[] = cards.map((card) => ({
    key: card.key,
    content: (
      /* `h-full` para o card preencher o slide: o trilho do Swiper iguala a
         altura pela do slide mais alto, e sem isso o card mais curto flutuaria
         no topo do seu. */
      <IniciativaOverlayCard
        card={card}
        variant="hero"
        className="h-full"
        dense
        isEditMode={isEditMode}
        onEditItem={onEditItem}
      />
    ),
  }));

  return (
    <MPFCardCarousel
      name="iniciativas"
      slides={slides}
      slidesPerView={2.2}
      spaceBetween={16}
      showArrows={false}
      labels={{
        prev: 'Iniciativa anterior',
        next: 'Próxima iniciativa',
        first: 'Esta é a primeira iniciativa',
        last: 'Esta é a última iniciativa',
        bullet: 'Ir para a iniciativa {{index}}',
      }}
    />
  );
};

export default IniciativasCarouselMobile;
